import { useEffect, useState } from "react";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const target = new Date(targetDate);
    target.setHours(0, 0, 0, 0); // start of the day

    const diff = target - now;

    if (diff <= 0) return null;

    return {
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  });

  if (!timeLeft) return <span>✨ It’s time!</span>;

  return (
    <div style={{ fontSize: "1.5rem", letterSpacing: "2px" }}>
      wait for more{"  "}
      {String(timeLeft.hours).padStart(2, "0")} :
      {String(timeLeft.minutes).padStart(2, "0")} :
      {String(timeLeft.seconds).padStart(2, "0")}
    </div>
  );
};

export default CountdownTimer;
